export default "__VITE_ASSET__D8J7j2Of__"